import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Portal from "./Portal";

const Modal = forwardRef((props, ref) => {
  const [display, setDisplay] = useState(false);

  const modalElRef = useRef();

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        handleClose();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  useImperativeHandle(ref, () => {
    return {
      openModal: () => handleOpen(),
      closeModal: () => handleClose(),
    };
  });

  const handleOpen = () => {
    setDisplay(true);
    modalElRef?.current?.focus(); // To ensure arrow keyboard presses work
  };

  const handleClose = () => {
    setDisplay(false);
  };

  const onKeyDownHandler = (ev) => {
    if (ev?.keyCode === 37 && props.currentIndex > 0) {
      props.carouselItemChangeHandler(true);
    }

    if (ev?.keyCode === 39 && props.currentIndex < props.totalItems - 1) {
      props.carouselItemChangeHandler(false);
    }
  };

  if (display) {
    return (
      <Portal>
        <div
          className={`modal brand-modal ${props.modalClassName}`}
          tabIndex="-1"
          role="none"
          onKeyDown={onKeyDownHandler}
          ref={modalElRef}
        >
          <div
            className="brand-modal-background"
            onClick={handleClose}
            onKeyDown={handleClose}
            role="none"
            tabIndex="-1"
          />
          <div
            className={`modal-dialog modal-dialog-centered d-flex flex-column align-items-center justify-content-center ${props.modalDialogClassName}`}
            role="dialog"
          >
            <div className="modal-content">
              <FontAwesomeIcon
                icon="times"
                onClick={handleClose}
                onKeyDown={handleClose}
                className="pb-2 ms-auto brand-text-white brand-cursor"
              />
              {props.children}
            </div>
          </div>
        </div>
      </Portal>
    );
  }

  return null;
});

export default Modal;

const ModalBody = ({ children, modalBodyClassName }) => {
  return (
    <div className={`modal-body ${modalBodyClassName}`}>
      <div className="container-fluid">{children}</div>
    </div>
  );
};

const ModalFooter = ({ children }) => {
  return (
    <div className="modal-footer">
      <hr />
      {children}
    </div>
  );
};

export { ModalBody, ModalFooter };
